var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { downloadFile } from '@/util/helper';
import { Download01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIModal, UIModalFooter, UIModalHeader } from '@gohighlevel/ghl-ui';
import { onBeforeMount, onBeforeUnmount, ref } from 'vue';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import { useStore } from '../store';
import { getDownloadUrl } from '../util/helper';
import { GOOGLE_DRIVE } from 'src/util/const_helper';
import MediaServices from '@/services/MediaService';
import { PRIVATE } from '@/helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DownloadFileModal',
    setup(__props) {
        const showModal = ref(false);
        const processing = ref(false);
        const emitter = useEmitter();
        const store = useStore();
        const { sendNotification } = useEvent();
        function hideModal() {
            showModal.value = false;
        }
        const onClickDownload = () => __awaiter(this, void 0, void 0, function* () {
            showModal.value = false;
            store.processingType = 'downloading';
            store.selectedItems.forEach((item) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    store.setProcessingQueue(item);
                    if (item.size >= 2000000000) {
                        store.updateProcessingQueue({
                            _id: item._id,
                            status: 'failed',
                            processed: true,
                        });
                    }
                    else {
                        let fileUrl = item.url;
                        // For private files first get the signed url and then download with that url
                        if (item.isPrivate) {
                            const { data: { url }, } = yield MediaServices.getSignedUrl({
                                altId: item.altId,
                                fileId: item._id,
                                contentType: item.contentType,
                                mode: PRIVATE,
                            });
                            fileUrl = url;
                        }
                        const isDownloaded = yield downloadFile({
                            fileUrl: store.activeCategory.includes(GOOGLE_DRIVE)
                                ? getDownloadUrl(item)
                                : fileUrl,
                            name: item.name,
                            openFileInNewTab: false,
                            accessToken: store.activeCategory.includes(GOOGLE_DRIVE)
                                ? store.activeGoogleConnection.token
                                : undefined,
                        });
                        if (isDownloaded) {
                            store.updateProcessingQueue({
                                _id: item._id,
                                status: 'success',
                                processed: true,
                            });
                        }
                        else {
                            store.updateProcessingQueue({
                                _id: item._id,
                                status: 'failed',
                                processed: true,
                            });
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                    sendNotification({
                        type: 'error',
                        duration: 5000,
                        title: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : 'Something went wrong',
                    });
                }
            }));
        });
        onBeforeMount(() => {
            emitter.on('showDownloadFileModal', () => {
                showModal.value = true;
            });
        });
        onBeforeUnmount(() => {
            emitter.off('showDownloadFileModal');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: showModal.value,
                "onUpdate:show": hideModal,
                id: "download-file-modal"
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        type: "custom",
                        icon: _unref(Download01Icon),
                        title: _ctx.$t('common.download'),
                        description: _ctx.$t('common.downloadConfirmation', [_unref(store).selectedItems.length]),
                        onClose: hideModal,
                        id: "modal-header"
                    }, null, 8 /* PROPS */, ["icon", "title", "description"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('common.download'),
                        negativeText: _ctx.$t('common.cancel'),
                        onPositiveClick: onClickDownload,
                        onNegativeClick: hideModal,
                        id: "modal-footer",
                        type: "primary",
                        loading: processing.value,
                        disabled: processing.value
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
